import { z } from 'zod';

export const waConnectSchema = z.object({
  phoneNumberId: z.string().trim().regex(/^\d{5,25}$/, { error: 'The Phone number ID is a long number from Meta (WhatsApp → API Setup).' }),
  wabaId: z.string().trim().regex(/^\d{5,25}$/, { error: 'The WhatsApp Business Account ID is a long number from Meta.' }),
  accessToken: z.string().trim().min(20, { error: 'Paste the permanent access token from Meta.' }).max(1000),
  appSecret: z.string().trim().regex(/^[a-f0-9]{32}$/i, { error: 'The App secret is 32 letters and numbers (Meta app → Settings → Basic).' }),
});

export const waSendTextSchema = z.object({ text: z.string().trim().min(1, { error: 'Type a message first.' }).max(4096) });

export const waSendTemplateSchema = z.object({
  templateName: z.string().min(1).max(512),
  language: z.string().min(2).max(15),
  params: z.array(z.string().max(1000)).max(20).default([]),
});

/** Where a campaign placeholder ({{1}}, {{2}}…) gets its value for each lead. */
export const waVariableSchema = z.object({
  source: z.enum(['name', 'first_name', 'city', 'company', 'owner', 'text']).or(z.string().regex(/^custom\.[a-z][a-z0-9_]*$/)),
  value: z.string().max(500).optional(),
});

export const waCampaignSchema = z.object({
  name: z.string().trim().min(2, { error: 'Give the campaign a name.' }).max(100),
  templateName: z.string().min(1).max(512),
  language: z.string().min(2).max(15),
  variables: z.array(waVariableSchema).max(20).default([]),
  /** Same filters as the leads list (status, source, campaign, tag, owner…). */
  filters: z.record(z.string(), z.string()).default({}),
  scheduledAt: z.iso.datetime().nullable().optional(),
});

export const waQuickReplySchema = z.object({
  title: z.string().trim().min(1).max(60),
  body: z.string().trim().min(1).max(4096),
});
